const getPathFromUrl = (url: string) => {
  return url.split('?')[0];
}

export function remoteUrl(this: any, path: any) {
  if (!path) {
      return path;
  }

  const slash = path.startsWith('/') ? '' : '/';
  return `${this.baseURL}${slash}${path}`;
}

export function urlWithParams(path: string, params?: object) {
  let fullPath = path;
  let query = '?';

  if (params) {
    for (let [key, value] of Object.entries(params)) {
      if(value) {
        query += `${key}=${value}&`
      }
    }

    fullPath += query.slice(0,-1);
  }

  return fullPath;
}

// export
export const queryParams = {
  get(searchParams: any, name: string) {
    const param: string | null = searchParams.get(name);
    return param ? param : undefined;
  },

  getInt(searchParams: any, name: string) {
    const param: string | null = searchParams.get(name);
    return param ? parseInt(param, 10) : undefined;
  },

  requestParams(searchParams: any, params: any, names: string | string[], defaults: any = {}) {
    if (typeof names === 'string') {
      names = [names];
    }

    names.forEach((name) => {
      const param = queryParams.get(searchParams, name);

      if (param) {
        params[name] = param;
      }
    });

    Object.keys(defaults).forEach((key) => {
      if (params[key] === undefined) {
        params[key] = defaults[key];
      }
    });

    return params;
  }
}

export const isExternalURL = (url: string) => {
  try {
    return new URL(url).origin !== window.location.origin;
  } catch (error) {
    return false;
  }
}

export const isActiveUrl = (baseUrl: string, pathname: string) => {
  const basePath    = getPathFromUrl(baseUrl);
  const currentPath = getPathFromUrl(pathname);

  return currentPath.includes(basePath);
}
